const i = {
  name: "CrossCircleFill",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM9.00015 7.58582L7.58594 9.00003L10.5859 12L7.58594 15L9.00015 16.4142L12.0002 13.4142L15.0002 16.4142L16.4144 15L13.4144 12L16.4144 9.00003L15.0002 7.58582L12.0002 10.5858L9.00015 7.58582Z" fill="currentColor"/>
</svg>
  `
};
export {
  i as CrossCircleFill
};
